/* import __COLOCATED_TEMPLATE__ from './permissions-request.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();